export const SourceRemoveReasonTypes = "unserviceableremovereasontypes";

export const TitleRemoveReasonTypes = {
  list: "Remove Reason List",
  edit: "Edit Remove Reason",
  create: "Create Remove Reason",
};
